import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { errorWarning } from "../errorWaringFormMessage";

/** returns a component for the input fields with validations included for the use of the Redux-Form */
export const InputField = ({
  input,
  autoComplete,
  disabled,
  label,
  type,
  placeholder,
  customClass,
  meta: { touched, error, warning },
}) => {
  // Custom class
  let defaultClass = "form-control";
  if (customClass) defaultClass = customClass;

  // Validate auto complete
  let fieldAutoComplete = "";
  if (
    autoComplete !== null &&
    autoComplete !== undefined &&
    autoComplete !== ""
  ) {
    fieldAutoComplete = autoComplete;
  }

  return (
    <div className={classnames({ "has-error": touched && error })}>
      <input
        {...input}
        placeholder={placeholder}
        type={type}
        className={defaultClass}
        autoComplete={fieldAutoComplete}
        disabled={disabled}
      />
      {errorWarning(touched, error, warning)}
    </div>
  );
};

/**
 * Allowed Props
 * @type {{
 *  placeholder: string, Description of the text that appears in the field.
 *  type: string, Type of input that will be created, eg: text, number, etc.
 *  label: string, Description of the field.
 *  }}
 */
InputField.propTypes = {
  placeholder: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
};

/** returns a component for the input fields with validations included for the use of the Redux-Form */
export const TextAreaField = ({
  input,
  label,
  type,
  direction,
  rows,
  placeholder,
  customClass,
  meta: { touched, error, warning },
}) => {
  let defaultClass = "form-control";
  if (customClass) defaultClass = customClass;

  return (
    <div className={classnames({ "has-error": touched && error })}>
      <textarea
        {...input}
        className={defaultClass}
        placeholder={placeholder}
        rows={rows}
        style={direction}
      />
      {errorWarning(touched, error, warning)}
    </div>
  );
};

export const CheckboxField = ({
  input,
  label,
  type,
  direction,
  rows,
  placeholder,
  customClass,
  meta: { touched, error, warning },
}) => {
  // let defaultClass = "form-control";
  // if (customClass) defaultClass = customClass;

  return (
    <div>
      <input {...input} type="checkbox" className="colored-blue" id="check" />
      <span className="fake-input" />
    </div>
  );
};

/**
 * Allowed Props
 * @type {{
 *  placeholder: string, Description of the text that appears in the field.
 *  type: string, Type of input that will be created, eg: text, number, etc.
 *  label: string, Description of the field.
 *  rows: integer, Number of rows the textarea contains
 *  }}
 */
TextAreaField.propTypes = {
  placeholder: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  rows: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/modules/NTICore/component/Form/InputField/index.js